import React, { useCallback } from 'react';
import { FormattedMessage } from 'react-intl';
import { connect } from 'react-redux';
import { Dropdown, List } from 'semantic-ui-react';
import findResult from '@/utils/resultsHelper';
import { vocabularyCodes } from '@/vocabularies/constants';
import { states } from '@/constants/lifecycle';
import { editRoleActionsProperty } from '../actions';
import availableRoleActions from '../helper';

const listItems = (code, category, roleActions) => roleActions.map(({ name, title }) => ({
  key: `role_actions_${name}_${code}_${category}`,
  text: name,
  value: name,
  description: title,
}));

const RoleActionsDropdown = ({
  category,
  code,
  readStatus,
  roleActions,
  updateValues,
  values,
}) => {
  const onChange = useCallback((e, { value }) => {
    const availableSelected = availableRoleActions(roleActions, value);
    updateValues(availableSelected);
  }, []);

  return (
    <List className="aridhia-role-actions">
      <List.Item>
        <List.Header>
          <FormattedMessage id="role.actions.title" />
        </List.Header>
        <Dropdown
          loading={readStatus === states.PENDING}
          fluid
          selection
          multiple
          value={values}
          options={listItems(code, category, roleActions)}
          onChange={onChange}
        />
      </List.Item>
    </List>
  );
};

const mapStateToProps = ({
  roles: { activeRoleActions },
  vocabularies: { vocabularies },
}) => {
  const { roleActions } = findResult(vocabularies, 'all', vocabularyCodes.ROLE_ACTIONS);

  return {
    values: availableRoleActions(roleActions, activeRoleActions.roleActions),
    readStatus: activeRoleActions.readStatus,
    roleActions,
  };
};

const mapDispatchToProps = (dispatch, { category, code }) => ({
  updateValues: (values) => dispatch(editRoleActionsProperty(code, category, values)),
});

export default connect(mapStateToProps, mapDispatchToProps)(RoleActionsDropdown);
